// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__30B7Q","icon":"Alert_icon__3GYKZ","content":"Alert_content__1Ui56"};